<template>
	<div class="share-btns" @click="expanded = true">

		<Download :class="{ hide: hover }" :image="image"/>

		<div class="btn email" @click="hover = true" :class="{ expanded: hover, sent: sent }">
			<Email :image="image"/>
			<h3 v-if="sent">Sent!</h3>
			<form v-else @submit="sendEmail" class="email-field">
				<input autofocus type="email" v-model="email">
			</form>
		</div>

	</div>
</template>

<script>
	import Email from './images/email';
	import Download from './images/download';

	export default {
		name: 'emailButton',
		props: [ 'image' ],
		data() {
			return {
				hover: false,
				email: '',
				sent: false,
			};
		},
		components: {
			Email,
			Download
		},
		methods:{
			sendEmail(ev) {
				ev.preventDefault();

				var data = {
					from: 'Milkshake Studio <no-reply@milkshake.studio>',
					to: this.email,
					subject: 'Happy Holidays from Milkshake Studio',
					html: 
						`<html>
								<head>
									<title>Milkshake Holiday Photobooth</title>
								</head>
								<body>
									<p>Hey!</p>
									<p>We hope you enjoyed the party.</p>
									<p><img src="${this.image}"></p>
									<p>🎉Happy Holidays from The Milkshake Team!🎉</p>
								</body>
						</html>`
				};

				this.axios.post('https://us-central1-holidayparty-21ef5.cloudfunctions.net/app/send', data).then(res=>{
					if(res.status == 200) {
						this.sent = true;
						console.log('RES', res);
					}
				})
			}
		}
	}
</script>